module.exports = __webpack_public_path__ + "img/down_arrow.92e0ce7e.svg";